import Vue from "vue";
import Offset from "@/components/helper/Offset";
import Card from "@/components/material/Card";
import ChartCard from "@/components/material/ChartCard";
import Notification from "@/components/material/Notification";
import StatsCard from "@/components/material/StatsCard";
import ProductCard from "@/components/material/ProductCard";
import ProductSelector from "@/components/material/ProductSelector";

Vue.component(Offset.name, Offset);
Vue.component(Card.name, Card);
Vue.component(ChartCard.name, ChartCard);
Vue.component(Notification.name, Notification);
Vue.component(StatsCard.name, StatsCard);
Vue.component(ProductCard.name, ProductCard);
Vue.component(ProductSelector.name, ProductSelector);
